import { render, staticRenderFns } from "./purchaseModal.vue?vue&type=template&id=544555ca&"
import script from "./purchaseModal.vue?vue&type=script&lang=js&"
export * from "./purchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./purchaseModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports